export default "__VITE_ASSET__nqVfWpZi__"